/* eslint-disable global-require */
// Imports
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index'),
        },
        {
          path: 'about',
          name: 'Products & Services',
          component: () => import('@/views/about/Index'),
          meta: { src: require('@/assets/about.jpg') },
        },
        {
          path: 'contact-us',
          name: 'Contact',
          component: () => import('@/views/contact-us/Index'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index'),
        },
      ],
    },

  ],
});

export default router;
